import React from 'react';
import { useFormControlContext } from './_FormControlContext.js';
import { InputLabel } from '../internal/components/InputLabel.js';

const FormControlLabel = ({
  as,
  children,
  htmlFor,
  id,
  visuallyHidden,
  requiredIndicator = true,
  requiredText,
  sx,
  className,
  ...props
}) => {
  const {
    disabled,
    id: formControlId,
    required
  } = useFormControlContext();

  /**
   * Ensure we can pass through props correctly, since legend/span accept no defined 'htmlFor'
   */
  const labelProps = as === 'legend' || as === 'span' ? {
    as,
    id,
    className,
    visuallyHidden,
    required,
    requiredText,
    requiredIndicator,
    disabled,
    sx,
    ...props
  } : {
    as,
    id,
    className,
    visuallyHidden,
    htmlFor: htmlFor || formControlId,
    required,
    requiredText,
    requiredIndicator,
    disabled,
    sx,
    ...props
  };
  return /*#__PURE__*/React.createElement(InputLabel, labelProps, children);
};
FormControlLabel.displayName = "FormControlLabel";

export { FormControlLabel as default };
